import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class ActivitiesService {
  constructor(private http: HttpClient) {}

  public query(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/activities`;
    return this.http
      .get(url, { params })
      .pipe(map((data: any) => data.activities || []));
  }
}
